import styled from 'styled-components';

export const GridColumns = styled.div<{ $isMobile: boolean }>`
    display: grid;
    grid-template-columns: ${({ $isMobile }): string => ($isMobile ? 'auto' : 'auto auto')};
    column-gap: ${({ $isMobile }): string => ($isMobile ? 'none' : '40px')};
    row-gap: ${({ $isMobile }): string => ($isMobile ? '40px' : 'none')};
`;

export const HeaderTextWrapper = styled.div`
    display: grid;
    row-gap: 8px;
`;

export const LeftColumnWrapper = styled.div`
    display: grid;
    row-gap: 40px;
`;

export const ContentWithCheckboxWrapper = styled.div`
    display: grid;
    row-gap: 20px;
`;

export const ContentWithCheckbox = styled.div`
    display: grid;
    grid-template-columns: 24px auto;
    column-gap: 16px;
`;

export const ButtonsWrapper = styled.div`
    display: flex;
    gap: 32px;
    flex-wrap: wrap;
`;
